import { render } from "./bankAccountData.vue?vue&type=template&id=7c1a1061&ts=true"
import script from "./bankAccountData.vue?vue&type=script&lang=ts"
export * from "./bankAccountData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__